{
  "seed": 1337,
  "tile": 40,
  "chunkTiles": { "w": 24, "h": 18 },
  "voidY": 480,
  "spawn": { "x": 640, "y": -3600 },
  "spawnPad": { "count": 5, "spreadChunks": 4 },

  "floor": "lava",
  "floors": {
    "lava": { "bounded": true,  "damage": 12 },
    "none": { "bounded": false, "damage": 0  }
  },

  "biome": {
    "noise": { "scaleX": 560, "scaleY": 190, "threshold": 0.2, "octaves": 2 }
  },

  "features": {
    "void": 0.06,
    "fortress": 0.06,
    "fortressCell": 6,
    "doorOpenChance": 0.15
  },

  "structures": {
    "sanctuary": 0.07
  }
}
